import React from 'react';
import {
	useClassNames,
} from '@common';

import {
	MeetingStatusInfo,
} from '@api';

interface MeetingStatusProps {
	status: MeetingStatusInfo,
}

import './MeetingStatus.scss';

function MeetingStatus(props: MeetingStatusProps): JSX.Element {
	const {
		status,
	} = props;

	const classes = useClassNames(
		'meeting-status',
		status.alias.toLowerCase(),
	);

	return (
		<span className={classes}>
			{status.name || '—'}
		</span>
	);
}

export {MeetingStatus};